import styled, { css } from 'styled-components';
import { colors } from '@alixpartners/ui-components';

interface ICollapsedProps {
  isCollapsed: boolean;
}

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  cursor: default;
`;

export const HeaderLabel = styled.div`
  display: flex;
  color: ${colors.grey5};
  font-size: 11px;
  letter-spacing: 0.8px;
  text-transform: uppercase;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 16px;
  letter-spacing: 0.3px;
  color: ${colors.grey7};
`;

export const ContentWrapper = styled.div<ICollapsedProps>`
  height: 100%;
  overflow: hidden;
  margin-bottom: 16px;

  ${({ isCollapsed }) =>
    isCollapsed &&
    css`
      margin-bottom: 0;
      height: 0;
    `};
`;

export const IconWrapper = styled.div<ICollapsedProps>`
  display: flex;
  cursor: pointer;
  transition: 0.15s transform ease-in-out;
  height: 28px;
  width: 28px;
  margin-right: 5px;

  ${({ isCollapsed }) =>
    !isCollapsed &&
    css`
      transform: rotate(180deg);
    `};
`;
